import Api from './rest/TeamMember';

export default new Api();
